import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { NoteDetail, UUID } from "@/core/types";

import { getNoteDetails } from "../queryFunctions/getNoteDetails";
import { noteKeys } from "../keyFactory";

type UseNoteDetailsProps<TData = NoteDetail> = {
  noteId: UUID;
  patientId: UUID;
  select?: (data: NoteDetail) => TData;
};

type NoteQueryOptions = UseQueryOptions<
  NoteDetail,
  unknown,
  NoteDetail,
  ReturnType<typeof noteKeys.details>
>;

export function useNoteDetails<TData = NoteDetail>({
  noteId,
  patientId,
  select,
}: UseNoteDetailsProps<TData>) {
  return useQuery({ ...optionFactory(patientId, noteId), select });
}

export function optionFactory(patientId: UUID, noteId: UUID) {
  return {
    queryFn: () => getNoteDetails({ noteId, patientId }),
    queryKey: noteKeys.details(noteId),
  } satisfies NoteQueryOptions;
}
